import {
  getMessaging,
  getToken,
  isSupported,
  onMessage,
} from 'firebase/messaging';

import {StorageKeys} from '../storage/type';
import {WebConfig} from '../../../src/utils/types';
import {getConfig} from '../../../src/utils/appInfo';
import {initializeApp} from 'firebase/app';
import {storage} from '../storage';
import {useRegisterDeviceForNotifications} from '../../onBoarding/hooks';

const firebaseConfig = {
  apiKey: getConfig(WebConfig.firebaseApiKey),
  authDomain: getConfig(WebConfig.firebaseAuthDomain),
  databaseURL: getConfig(WebConfig.firebaseDatabaseUrl),
  projectId: getConfig(WebConfig.firebaseProjectId),
  storageBucket: getConfig(WebConfig.firebaseStorageBucket),
  messagingSenderId: getConfig(WebConfig.firebaseMessagingSenderId),
  appId: getConfig(WebConfig.firebaseAppId),
  measurementId: getConfig(WebConfig.firebaseMeasurementId),
};

const vApiKey = getConfig(WebConfig.firebaseVapidKey);

const firebaseApp = initializeApp(firebaseConfig);

class FCMNotification {
  async requestPermissionSecondTimeAppOpen() {
    const info = await storage.getItem(StorageKeys.hasAppPreviouslyOpen);
    if (!info) return storage.setItem(StorageKeys.hasAppPreviouslyOpen, 'true');
    this.requestUserPermission();
  }

  action() {
    // Add any action to perform on mount
  }

  requestUserPermission = async () => {
    const supported = await isSupported();
    if (!supported) return;
    const messaging = getMessaging(firebaseApp);
    const {registerDeviceForNotifications} =
      useRegisterDeviceForNotifications();
    try {
      const webGlobal = global as any;
      const permission = await webGlobal.Notification.requestPermission();
      if (permission === 'granted' && 'serviceWorker' in webGlobal.navigator) {
        const registration = await webGlobal.navigator.serviceWorker.register(
          '/firebase-messaging-sw.js',
        );

        const currentToken = await getToken(messaging, {
          vapidKey: vApiKey,
          serviceWorkerRegistration: registration,
        });
        if (currentToken) {
          this.onMessage();
          await registerDeviceForNotifications(currentToken);
        }
        return currentToken;
      }
    } catch (err: any) {
      // eslint-disable-next-line no-console
      console.log('err ==>', err);
    }
  };

  onMessage = async () => {
    const supported = await isSupported();
    if (!supported) return;
    onMessage(getMessaging(firebaseApp), payload => {
      if (!payload?.data) return;
      const notif = JSON.parse(payload.data.notification);
      // eslint-disable-next-line no-console
      console.log('notification ---->', notif);
    });
  };
}

export const notification = new FCMNotification();
export {notifee} from './notifee';
